<template>
  <mds-dialog
    v-model="dialog.toggle"
    action-required
    :title="dialog.title"
    width="500px"
  >
    {{ dialog.message }}
    <template #mds-dialog-actions-left>
      <mds-button
        v-for="button in dialog.leftButtons"
        :key="button.id"
        type="button"
        :variation="button.variation"
        @click="
          dialog.toggle = !dialog.toggle;
          $emit('buttonclick', button.emitevent);
        "
      >
        {{ button.text }}
      </mds-button>
    </template>
    <slot name="dialogBody"></slot>
    <template #mds-dialog-actions-right>
      <mds-button-container right-aligned>
        <mds-button
          v-for="button in dialog.rightButtons"
          :key="button.id"
          type="button"
          :variation="button.variation"
          @click="
            dialog.toggle = !dialog.toggle;
            $emit('buttonclick', button.emitevent);
          "
        >
          {{ button.text }}
        </mds-button>
      </mds-button-container>
    </template>
  </mds-dialog>
</template>
<script>
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsDialog from "@mds/dialog";
export default {
  props: {
    dialog: {
      type: Object,
    },
  },
  components: {
    MdsDialog,
    MdsButton,
    MdsButtonContainer,
  },

  mounted() {},
  async created() {},
  methods: {},
};
</script>
<style lang="scss" module></style>
